<template>
  <div class="home-container" :style="{backgroundColor: $router.history.current.name.indexOf('user') === -1 ? '#fff' : '#F7F8FC'}" ref="container" @click="handleDocument">
    <Header />
    <JumpPrompt :id='id' @close='close' v-show="isShow"/>
    <div
      v-if="$router.history.current.name.indexOf('user') === -1"
      class="main"
    >
      <Router-view :key="key" />
      <div class="fixed">
        <div class="icon to-main" @click="toMain"></div>
        <div class="icon to-down" @click="toDown"></div>
        <div class="icon to-top" v-if="showTop" @click="toTop"></div>
      </div>
    </div>
    <div class="userMain" v-else>
      <Router-view />
      <div class="fixed">
        <div class="icon to-main" @click="toMain"></div>
        <div class="icon to-down" @click="toDown"></div>
        <div class="icon to-top" v-if="showTop" @click="toTop"></div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./header";
import Footer from "./footer";
import { mapState } from "vuex";
import JumpPrompt from '@/components/pager/JumpPrompt.vue'
export default {
  name: "Home",
  data(){
    return{
      isShow:false,
      id:'',
      showTop: false,
    }
  },
  components: {
    Header,
    Footer,
    JumpPrompt
  },
  computed: {
    ...mapState(["hasLogin"]),
    // 唯一的一个Key用于搜索后页面二次刷新
    key() {
      return this.$route.name
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  mounted() {
    // 初次加载时触发该事件,开启提示保存ID
    this.$bus.$on('toBJUrl',(id)=>{
      this.isShow = true
      this.id = id
    })
    // console.log(this.key,'唯一的key值测试')
    // console.log(this.hasLogin, "this.hasLogin");
    // if(this.hasLogin){
    // this.getUserInfo();
    // }
    document.title = "中文知识网";
    document.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    close(){
      this.isShow = false
    },
    toTop() {
      //滚动条回到最顶部
      document.documentElement.scrollTop = 0;
      // document.querySelector(".main").scrollTop = 0;
    },
    async getUserInfo() {
      let data = await this.$apis.loginServe.getUserInfo();
      console.log(data, "data");
      let userObj = {
        token: sessionStorage.getItem("token"),
        hasLogin: true,
        userInfo: data.content,
      };
      console.log(userObj);
      this.$store.commit("loginInfo", userObj);
    },
    toMain() {
      // 跳转静态页面首页
      window.location.href = this.$global.SeoUrl
      document.documentElement.scrollTop = 0;
    },
    toDown() {
      let routeData = this.$router.resolve({ path: '/jumpdownload' }); 
      window.open(routeData.href, '_blank');
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.showTop = scrollTop > 500 ? true : false
      this.$bus.$emit("mainScroll", this.$refs.container);
    },
    handleDocument(e) {
      this.$bus.$emit("mainDocument", e);
      this.$bus.$emit('isHot',false)
    },
  },
};
</script>
<style lang="scss">
.fixed {
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 100;
  .icon {
    background-size: 100% 100%;
    width: 56px;
    height: 56px;
    cursor: pointer;
    &.to-top {
      background-image: url("~@/assets/img/qietu/totop.png");
    }
    &.to-down {
      background-image: url("~@/assets/img/qietu/todown.png");
    }
    &.to-main {
      background-image: url("~@/assets/img/qietu/tomain.png");
    }
  }
}
.home-container {
  width: 100%;
  min-width: 1416px;
  height: 100%;
  position: relative;
  .main {
    // width: 1200px;
    min-height: 90vh;
    margin: 0 auto;
    padding-top: 135px;
  }
  .userMain {
    // width: 1200px;
    min-height: 900px;
    margin: 110px auto 20px;
  }
}
</style>
